import React from 'react';

import * as logger from 'utilities/loggerx';

import './styles.less';

export default class ErrorBoundary extends React.Component {
  state = {
    error: null,
  };

  componentDidCatch(error, errorInfo) {
    logger.error(error, errorInfo);
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          An error occurred on the page: {this.state.error.toString()}
        </div>
      );
    }

    return <React.Fragment>{this.props.children || null}</React.Fragment>;
  }
}
